export default __webpack_public_path__ + "static/media/GESTÃO AMBIENTAL.66b0ed25.pdf";